import {Component, ChangeDetectionStrategy, Input} from '@angular/core';
import { EXTERNAL_PATH, getRouterLink, ROUTE_PATH } from '@common/types/route-path.enum';
import {I18nService} from '../../../services/i18n.service';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  getRouterLink = getRouterLink;
  ROUTE_PATH = ROUTE_PATH;
  EXTERNAL_PATH = EXTERNAL_PATH;
  currentYear = (new Date()).getFullYear();

	showBannerOnly$ = new BehaviorSubject(true);
	@Input('showBannerOnly')
	set _showBannerOnly(showBannerOnly: boolean) {
		this.showBannerOnly$.next(showBannerOnly);
	}

  constructor(private i18nService: I18nService,
              private translateService: TranslateService) {
  }

  get languageName() {
    return this.i18nService.languageName;
  }

  get langChange() {
    return this.translateService.onLangChange;
  }
}
